import { ChangeDetectorRef, Injectable, Renderer2 } from '@angular/core';

import { DomElement } from '../models';
import { EventType } from '../util';

@Injectable()
export class KeyDownListenerService {
  private documentKeyDownListener;
  private keyDownHandler: Function;

  constructor(private renderer: Renderer2, private cd: ChangeDetectorRef) {
  }

  public bindDocumentKeyDownListener(keyDownHandler: Function): void {
    if (!this.documentKeyDownListener) {
      this.keyDownHandler = keyDownHandler;
      this.documentKeyDownListener = this.renderer.listen(
        DomElement.Document,
        EventType.KeyDown,
        event => this.onDocumentKeyDown(event)
      );
    }
  }

  public unbindDocumentKeyDownListener(): void {
    if (this.documentKeyDownListener) {
      this.documentKeyDownListener();
      this.documentKeyDownListener = null;
      this.keyDownHandler = null;
    }
  }

  private onDocumentKeyDown(event: KeyboardEvent): void {
    this.keyDownHandler(event);
    this.cd.markForCheck();
  }

}
